import React from "react";
import CoreEngine from "../../core/CoreEngine";
import FormPage from "../../components/Form/FormPage";
import AppointmentSettingsForm from "./AppointmentSettingsForm";
import strings from "../../core/translate";

// Direct link version of the appointment settings dialog.
export default class MerchantBranchAppointmentSettingsAddUpdate extends CoreEngine {
  getContext() {
    const routeState = this.props.location.state || {};
    const { selectedBranch } = this.props.match.params;
    return {
      selectedBranch: routeState.selectedBranch || selectedBranch,
      selectedMerchant: routeState.selectedMerchant,
      branchName: routeState.branchName,
    };
  }

  handleDone = () => {
    const { selectedBranch, selectedMerchant, branchName } = this.getContext();
    this.props.history.push({
      pathname: `/admin/merchants-branches/${selectedBranch}/appointments-settings`,
      state: { selectedMerchant, selectedBranch, branchName },
    });
  };

  render() {
    const { selectedBranch, branchName } = this.getContext();
    const item = this.props.location.data;

    return (
      <FormPage
        title={
          item && item.id
            ? `${strings.edit} ${strings.appointment_settings}`
            : `${strings.add} ${strings.appointment_settings}`
        }
        subtitle={branchName}
      >
        <AppointmentSettingsForm
          item={item}
          branchId={selectedBranch}
          onSaved={this.handleDone}
          onCancel={this.handleDone}
        />
      </FormPage>
    );
  }
}
